import axios from "axios";

export const getAuthHeaders = async (auth) => {
  if (!auth.currentUser) {
    throw new Error("User not authenticated. Please log in again.");
  }
  const token = await auth.currentUser.getIdToken(true);
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const fetchCurrentUserApi = async (auth, API_BASE_URL) => {
  const headers = await getAuthHeaders(auth);

  const res = await axios.get(`${API_BASE_URL}/api/me/`, {
    headers,
    withCredentials: true,
  });

  return res.data;
};

export const fetchEventsApi = async (auth, API_BASE_URL) => {
  const headers = await getAuthHeaders(auth);

  const [eventRes, workRes] = await Promise.all([
    axios.get(`${API_BASE_URL}/api/event/`, { headers, withCredentials: true }),
    axios.get(`${API_BASE_URL}/api/work/`, { headers, withCredentials: true }),
  ]);

  return {
    events: eventRes.data,
    work: workRes.data,
  };
};

export const fetchHolidaysApi = async (API_BASE_URL) => {
  const res = await axios.get(`${API_BASE_URL}/api/holidays`);
  return res.data;
};

export const fetchBirthdaysApi = async (API_BASE_URL) => {
  const res = await axios.get(`${API_BASE_URL}/api/birthdays`);
  return res.data;
};

export const fetchEmployeesApi = async (API_BASE_URL) => {
  const res = await axios.get(`${API_BASE_URL}/api/employees`);
  return res.data;
};
